<template>
	<div>
		<!--<p class="mb-4">
			<router-link tag="a" :to="{ name : 'organization.courses.detail', params : { id: $route.params.id} }" class="button icon-button">
				<img src="../../../../assets/images/icons/solid/angle-left-white.svg" width="13" class="mr-2" />
				<span>BACK TO THE PROGRAM DASHBOARD</span>
			</router-link>
		</p>-->
		
    	<h2 class="mb-4 pb-2 mt-0 d-flex align-items-start">
	    	<span>{{ provider_data.first_name }} {{ provider_data.last_name }}<br/><small class="font-italic">ssn: {{ provider_data.ssn }}</small></span>
    	</h2>
    	<div class="row">
	    	<div class="col-12 col-md-6">
		    	<div class="profile-presentation mb-4">
			        <div class="h5 border-bottom pb-2 text-uppercase green">Profile</div>
	                <div class="row align-items-center">
		                <div class="col-12 col-sm-6 col-lg-5">
							<router-link :to="{name:'organization.providers.detail', params:{id:provider_data.id}}" tag="a" class="d-block thumb-container pb-100 profile-thumb circle-thumb" :style="{ 'background-image': 'url(data:image/jpeg;base64,' + provider_data.image + ')' }"></router-link>
		                </div><!--col-->
		                <div class="col-12 col-sm-6 col-lg-7">
			                <ul class="icon-list list-unstyled">
			                	<!--
			                	<li class="d-flex align-items-center mb-2 ">
				                	<span class="mr-2 bold green">SSN</span>
				                	<span><strong>{{ provider_data.ssn }}</strong></span>
				                </li>
				            -->
				                <li class="d-flex align-items-center mb-2 ">
				                	<span class="mr-2"><img src="../../../../assets/images/icons/solid/user_green.svg" width="22" /></span>
				                	<span><strong>{{ provider_data.first_name }} {{ provider_data.last_name }}</strong></span>
				                </li>
				                <li class="d-flex align-items-center mb-2">
				                	<span class="mr-2"><img src="../../../../assets/images/icons/solid/phone_green.svg" width="22" /></span>
				                	<span><strong>{{ provider_data.phone }}</strong></span>
				                </li>
				                <li class="d-flex align-items-center mb-2">
				                	<span class="mr-2"><img src="../../../../assets/images/icons/solid/envelope_green.svg" width="22" /></span>
				                	<span><strong>{{ provider_data.email }}</strong></span>
				                </li>
				                <li class="d-flex align-items-center mb-2">
				                	<span class="mr-2"><img src="../../../../assets/images/icons/solid/globe_green.svg" width="22" /></span>
				                	<span><strong>{{ provider_data.preferred_language}}</strong></span>
				                </li>
			                </ul> 
		                </div><!--col-->
	                </div><!--row-->
                </div><!--profile_presentation-->
                <div class="h5 border-bottom pb-2 text-uppercase green" @click="getMessages()"
                	v-if="user_meta_actions.includes('send_a_notification')">MESSAGES </div>
		    	<div class="conversation w-100 d-flex justify-content-end p-3 lightgray-content"
		    		v-if="user_meta_actions.includes('send_a_notification')">
			    	<div v-if="messages != null" class="flex-fill">
			    		<div v-if="messages.length > 0">
					    	<ul class="messages">
						    	<li class="answer" v-for="message in messages" v-if="message.from == 'provider'">
						    		<header class="d-flex justify-content-end mb-1">
							    		<!--<strong><small>{{ message.author }}</small></strong>-->
							    		<div class="date">{{ message.sent_at }} <!--{{ message.read_at }}--></div>
						    		</header>
						    		<div class="d-flex">
							    		<div class="thumb-container" 
							    				:style="{'background-image': 'url(data:image/jpeg;base64,'+provider_data.image+')'}"></div>
							    		<div class="message flex-fill">
							    			<span v-if="message.data">
								    			<p>Module: {{ message.data.module }}</p>
								    			<p>Lesson: {{ message.data.lesson }}</p>
								    		</span>
							    			{{ message.text }}
							    		</div>
						    		</div>
						    	</li>
						    	<li v-else>
						    		<header class="d-flex justify-content-end mb-1">
							    		<!--<strong><small>{{ message.author }}</small></strong>-->
							    		<div class="date"><!--Sent in-->{{ message.sent_at }} <!-- / Read at {{ message.read_at }} --></div>
						    		</header>
						    		<div class="d-flex">
							    		<div class="message flex-fill">{{ message.text }}
										</div>
										
							    		<div class="thumb-container" style="background-image: url(http://nevvon.com/logo.png)"></div>
						    		</div>
						    	</li>
					    	</ul>
			    		</div>
			    		<div v-else>
				    		<p class="mt-5 mb-5"><strong>There aren't messages in this conversation.</strong></p>
			    		</div>
				    	
				    	<div class="text-entry d-flex justify-content-between">
					    	<div class="flex-fill d-flex">
						    	<div class="input-content flex-fill m-0">
						    		<input type="text" class="flex-fill" 
										:disabled="!user_meta_actions.includes('send_a_notification')"
						    			placeholder="Type Message" v-model="text_to_send"
						    			@keyup="enterSendMessage"/>
						    	</div>
						    	<button :disabled="text_to_send === ''" class="button m-0" type="submit" @click="sendMessage" 	:class="{ 'button-disabled' : text_to_send === '' }">
						    		<img src="../../../../assets/images/icon_envelope_white.svg" class="mr-1" width="18" /> SEND
								</button>
					    	</div>
					    	<!--
					    	<div class="pl-2">
						    	<img src="../../../../assets/images/icons/solid/paperclip.svg" width="27" />
					    	</div>
					    -->
				    	</div>
			    	</div>
		    	</div><!--conversation-->
	    	</div><!--col-->
	    	<div class="col-12 col-md-6">
		    	
		    	<div class="h5 border-bottom pb-2 text-uppercase green">Program</div>
				<div class="lightgray-content p-4 mb-2" v-if="provider_data.progress != null">
					<div class="white-content p-3">
				    	<p class="border-bottom pt-2 pb-2 mb-0 d-flex align-items-center "><strong>Name</strong>: <span class="h2 green m-0 italic ml-2">{{ provider_data.progress.course.name }}</span></p>
		        		<p class="border-bottom pt-2 pb-2 mb-0"><strong>Description</strong>: {{ provider_data.progress.course.description }}</p>
		        		<p class="border-bottom pt-2 pb-2 mb-0 d-flex justify-content-start align-items-center w-100">
			        		<strong>Total lessons</strong>: <span class="h3 m-0 ml-2 mr-2 regular">{{ provider_data.progress.lessons_data.total }}</span> /
			        		<strong>Completed</strong>: <span class="h3 m-0 ml-2 mr-2 regular">{{ provider_data.progress.lessons_data.completed }}</span>
			        	</p>
			        	<p class="border-bottom pt-2 pb-2 mb-0 d-flex justify-content-start align-items-center w-100">
			        		<strong>Completed at</strong>: <span class="h3 m-0 ml-2 mr-2 regular">{{ provider_data.progress.provider_completion_date ?  provider_data.progress.provider_completion_date : '-'}}</span> 
			        	</p>
		        		<div class="border-bottom pt-2 pb-2 mb-0 d-sm-flex justify-content-between align-items-center">
			        		<strong class="mr-2">Progress: </strong>
			        		<div class="completion-bar">
				        		<div v-bind:style="{ width: provider_data.progress.lessons_data.completion + '%' }"></div>
				        		<span>{{ provider_data.progress.lessons_data.completion }}%</span>
			        		</div>
		        		</div>
					</div>
	        		
					<div class="program-detail" v-if="provider_data.progress != null">
				
        		<!-- <div class="h5 border-bottom pb-2 mt-5 mb-2">Modules</div> -->
        	
        	 
			    <div no-body class="border-bottom mb-1"  v-for="(module, i) in provider_data.progress.course.modules" >
			        <div v-b-toggle="'accordion'+(i + 1)" variant="info" class="variant cursor-pointer h6 pt-3 pb-3 m-0 regular">
				        <!-- <span class="green">Module {{i+1 }}.</span> --> 
				        <div class="row">
				        	<div class="col-12 col-xl-6">

				        		<strong v-if="!!module.name['EN']">{{ module.name['EN'] }} ({{ module | lessons_completed }}/{{ module.lessons.length }})</strong>
				        		<strong v-else>{{ module.title }} ({{ module | lessons_completed }}/{{ module.lessons.length }})</strong>
				        	</div>
				        	<div class="col-11 col-xl-4">
				        		<div class="completion-bar completion-bar-xs">
					        		<div v-bind:style="{ width:  module.comp_percent + '%' }"></div>
					        		<span>{{ module.comp_percent }}%</span>
				        		</div>
				        	</div>
				        </div>
				    </div>
			      <b-collapse :id="'accordion'+(i+1)" visible accordion="my-accordion" role="tabpanel">
			        <div>
			       		<div class="white-content p-3 mb-3">
					        <!-- <div class="mb-3 text-uppercase bold text-underline">Lessons</div> -->
		        			<div>
				            	<ul class="lessons list-unstyled">
	            					<li v-for="(lesson, j) in provider_data.progress.course.modules[i].lessons">
	            						<div v-bind:class="{ completed : lesson.progress.completed }" class="pt-1 border-bottom pb-1 d-flex justify-content-between align-items-center ">
		            						<div class="mb-2">
		                						<a v-if="!!lesson.name['EN']" class="green" @click="showLessonDetail(lesson.id)"><strong>{{ j+1 }}</strong>. {{ lesson.name['EN']}} </a>
		                						<a v-else class="green" @click="showLessonDetail(lesson.id)"><strong>{{ j+1 }}</strong>. {{ lesson.title}} </a>
		                						
		                						<br />
		                						<span v-if="lesson.progress.completed"><small>(Completed at: {{ lesson.progress.completed_at }})</small></span>
		            						</div>

											<div class="actions d-flex justify-content-end">
												<span
													v-b-tooltip.hover
													title="Mark as completed"
													class="button m-0"
													v-if="!lesson.progress.completed && user_meta_actions.includes('fake_complete_actions')"
													@click="simulateCompletion(module.id, lesson.id)"
												><img src="../../../../assets/images/icons/solid/check_white.svg" width="9"  /></span>
											</div>
	                						
	                							<!--
	                						<div class="actions d-flex justify-content-end">
		                						
	                							<span v-b-tooltip.hover title="Mark as completed"  class="button m-0" v-if="!lesson.progress.completed" @click="markAsCompleted(lesson.id)"><img src="../../../../assets/images/icons/solid/check_white.svg" width="9"  /></span>

	                							<span  v-b-tooltip.hover title="View lesson details" class="button m-0 ml-1 text-center" @click="showLessonDetail(lesson.id)">
	                								<img src="../../../../assets/images/icons/solid/info_white.svg" width="5"  />
	                							</span>
	                							
	                						</div>
											-->
	                						<!--actisons-->
	            						</div>
	            					</li>
				            	</ul>
	        				</div>
			       		</div>
			        </div>
			      </b-collapse>
			    </div>
        	
        </div>
	        		
		    	</div>
		    	
	    	</div><!--col-->

	    	<div class="col-12 col-xl-5" style="display:none">
	        	<div id="selected-lesson" class="lightgray-content p-3" v-if="selected_lesson != null">
		    		<div class="d-flex justify-content-between ">
		    			<div class="h6 regular green text-uppercase">Lesson details</div>
		        		<button class="button green-button" @click="refreshStats">Refresh</button>
		    		</div>
		    		<div class="table-responsive">
						<table class="table table-bordered">
							<tr class="align-midle">
								<th class="text-center">Slide</th>
								<th class="text-center">Verb</th>
								<th class="text-center">Timestamp</th>
							</tr>
							<tr v-for="stat in stats" >
								<td><small>{{ stat.object_name }}</small></td>
								<td><small>{{ stat.verb }}</small></td>
								<td><small>{{ stat.timestamp }}</small></td>
							</tr>
						</table>
					</div>
					<b-pagination align="right" :total-rows="stats_pagination.total" 
								v-model="stats_pagination.current_page" 
								:per-page="stats_pagination.per_page" 
								@change="setPageStats">
			    	</b-pagination>
				</div>
        	</div>
    	</div><!--row-->
	</div>	
</template>

<script>
	
	
	import CourseProgressionChart from './../../../charts/CourseProgressionChart.js';
	
	export default {
		
	    components : {
	        CourseProgressionChart
	    },
		data : function(){
			return {
				id : this.$route.params.id,
				provider_id : this.$route.params.provider_id,
				agency_id :this.$route.query.agency_id,
				user_role: '',
				provider_data : {
					email : '',
					first_name : '',
					last_name : '',
					// dob : ''
				},
				progress : null, 
				course : null,
				stats_pagination : {
					current_page : 0,
					total : 0,
					per_page : 0,
					from : 0,
					to : 0
				},
				show_lesson_details : false,
				stats : [],
				selected_lesson : null,
				
				messages : null,
				text_to_send : '',
				user_meta_actions: localStorage.getItem('meta_actions')
			}
		},

		created : function(){
			this.permissions = this.$store.getters.getPermissions;
			this.user_role = this.$store.getters.getRole;
			console.log(this.permissions);

			this.getProvider();
			this.getMessages();

			/*setInterval(() => {
				this.refreshStats()
			}, 1000);*/
		},

		filters : {
			lessons_completed : function(module){
				var completed = 0;

				for(var i in module.lessons){
					if(module.lessons[i].progress.completed)
						completed++;
				}

				return completed;
			}
		},

		methods : {

			getProvider : function(){
				if(this.user_role === 'csm'){
						var params = {
							id: this.provider_id,
							filters:{
								provider_id : this.provider_id,
								organization_id :this.agency_id,
								progress : true,
								course_id : this.id,
								full : true
							}
					}
				}else{
					var params = {
						id : this.provider_id,
						filters : {
							progress : true,
							course_id : this.id,
							full : true
						}
					}

				}
		
					this.$store.dispatch('getProvider', params).then((res) => {
						this.provider_data = res.data.data;
						for(var i in this.provider_data.progress.course.modules){
							var module = this.provider_data.progress.course.modules[i];

							module.lessons_completed = 0;

							for(var j in module.lessons){

								if(module.lessons[j].progress.completed == 1){
									module.lessons_completed++;
								}
							}

							module.completion = ((module.lessons_completed / module.lessons.length) * 100).toFixed(0);
						}
					}).catch((error) => {	
						console.log(error);
					})

			},
			
			markAsCompleted : function(lesson_id){
				var params = {
					id : this.id, 
					provider_id : this.provider_id,
					lesson_id : lesson_id
				}

				this.$store.dispatch('markCourseProviderLessonCompleted', params).then((res) => {
					console.log(res);
					this.getProvider();
				}).catch((error) => {
					console.log(error);
				});
			},

			showLessonDetail : function(lesson_id){
				
				this.show_lesson_details = true;
				
				var params = {
					id : this.id,
					provider_id : this.provider_id,
					filters : {
						lesson_id : lesson_id,
						page : this.stats_pagination.current_page
					}
				}

				this.$store.dispatch('getCourseProviderProgress', params).then((res) => {
					this.selected_lesson = lesson_id;
					this.stats_pagination = res.data.meta;
					this.stats = res.data.data;
				}).catch((error) => {
					console.log(error);
				});
			},

			refreshStats : function(){
				this.showLessonDetail(this.selected_lesson);
			},

			setPageStats : function(page){
				this.stats_pagination.current_page = page;
				this.refreshStats();
			},
			getMessages : function(){
				if(this.user_role === 'csm'){
					var params = {
						id : this.id, 
						
						provider_id : this.provider_id,
						filters : {
							organization_id:this.agency_id,
						}
					}

				}else{
					var params = {
						id : this.id, 
						provider_id : this.provider_id
					}

				}
				

				this.$store.dispatch('getCourseProviderMessages', params).then((res) => {
					this.messages = res.data.messages;
					console.log(this.messages)
				}).catch((error) => {
					console.log(error);
				})
			},

			sendMessage : function(){
				if(this.user_role === 'csm'){
						var params = {
							id : this.id,
							provider_id : this.provider_id,
							text : this.text_to_send,
							filters : {
								organization_id:this.agency_id,
							}
						}
				}else{
						var params = {
							id : this.id,
							provider_id : this.provider_id,
							text : this.text_to_send
						}
				}
			
				this.$store.dispatch('sendMessageToCourseProvider', params).then((res) => {
					this.text_to_send = '';
					this.getMessages();
				}).catch((error) => {
					console.log(error);
				});
			},
			enterSendMessage : function(a,b,c){
				if(a.keyCode == 13 && this.text_to_send != '')
					this.sendMessage();
				
			},
			simulateCompletion(moduleId, lessonId) {
				const params = {
					course_id: this.provider_data.progress.course.id,
					module_id: moduleId,
					lesson_id: lessonId,
					provider_id: this.provider_id,
				};

				this.$store.dispatch('simulateLessonCompletion', params).then((res) => {
						// refresh screen
						this.getProvider();
						this.$snotify.success('Lesson simulated successfully.', {
							timeout: 2000,
							showProgressBar: true,
							closeOnClick: false,
							pauseOnHover: true
						});
					}).catch((error) => {
						console.log(error);
						this.$snotify.error('Lesson simulation failed.', {
							timeout: 2000,
							showProgressBar: true,
							closeOnClick: false,
							pauseOnHover: true
						});
					});
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/organizations/courses/providers/OrganizationCourseProviderDetailComponent.vue